import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = {
    key: 0,
    type: "button",
    class: "close",
    "data-dismiss": "alert",
    "aria-label": "Close"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { "aria-hidden": "true" }, "×", -1);
const _hoisted_5 = [
    _hoisted_4
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", {
            class: _normalizeClass(_ctx.classes),
            style: _normalizeStyle('width: 100%;' + _ctx.extraStyle),
            role: "alert"
        }, [
            (_ctx.minimal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createElementVNode("small", null, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default"),
                    (_ctx.dismissible)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_3, _hoisted_5))
                        : _createCommentVNode("", true)
                ]))
        ], 6)
    ]));
}
